import { RoleType } from './RoleType';

class Role {
  id = 0;

  customerId = '';

  customerName = '';

  type: RoleType = 'Client';
}

export default Role;
